
(function ($) {
    $.fn.sgkMore = function (options) {
        var fg;
        var defaults = $.extend({
            maxheight: 140,
            more: "mehr erfahren",
            less: "weniger anzeigen",
            text: true,
            icon: true,
            toggle: true,
            debug: false
        }, options);

        this.filter("div").each(function () {
            if (defaults.debug) {
                console.log("[sgk.more] init");
            }
            var div = $(this);
            var data = {};
            $.each(defaults, function (k, v) {
                if (typeof div.data(k) !== "undefined") {
                    data[k] = div.data(k);
                }
            });
            var settings = $.extend(Object.assign({}, defaults), data)
            if (settings.debug) {
                console.log(settings);
            }
            if (div.height() > settings.maxheight) {
                div.css({
                    "max-height": settings.maxheight
                });
                div.addClass("collapse show")

                var more = $("<a/>").addClass("more text-center");
                var icon = $("<i/>").addClass("fas fa-plus mr-1 p-1");
                if (settings.icon) {
                    more.append(icon);
                }
                if (settings.text) {
                    more.append(settings.more);
                }
                div.append(more);

                more.css("top", settings.maxheight - more.height());
                if (settings.toggle) {
                    more.on("click", function () {
                        div.toggleClass("collapse");
                        if (settings.text) {
                            $(this).get(0).childNodes[settings.icon ? 1 : 0].nodeValue = div.hasClass("collapse") ? settings.more : settings.less;
                        }
                        if (settings.icon) {
                            icon.toggleClass("fa-plus fa-minus");
                        }
                        return false;
                    })
                }
            }
        });
        return this;
    };

}(jQuery));


